import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        recuperarFontesPOL(filtro){
            return instance({
                method: 'post',
                baseURL,
                url: 'FontesPOL/RecuperarFontesPOL',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filtro),
            });
        },
        listarFontesPOL(filters) {
            return instance({
                method: 'post',
                baseURL,
                url: 'FontesPOL/ListarFontesPOL',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        atualizarFontesPOL(fontesPOL, idUserAlteracao) {
            return instance({
                method: 'post',
                baseURL,
                url: 'FontesPOL/EditarFontesPOL',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'fontesPOL': fontesPOL, 'idUserAlteracao': idUserAlteracao }),
            })
        },
        exportarFontesPOL() {
            return instance({
                method: 'get',
                baseURL,
                url: 'FontesPOL/ExportarFontesPOL',
                responseType: 'arraybuffer',
                headers: headers,
                //data: relatorio,
            });
        },
    }
    return apiCalls;
}